import { useContext } from 'react';
import { UserContext } from '../services/userContext';

export const useAuth = () => {
  return useContext(UserContext);
};
